import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { ApiDropDownRepository, IApiConfig } from '~repositories/ApiDropDownRepository';

export class SuggestionApiCalledUseCase {
    private apiDropDownRepository: ApiDropDownRepository;

    constructor() {
        this.apiDropDownRepository = diContainer.get(serviceNames.apiDropDownRepository);
    }

    public execute = async (apiConfig: IApiConfig) => {
        await this.apiDropDownRepository.loadSuggestionData(apiConfig);
    };
}
